<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
              <!-- Content Start -->
              <div class="col-lg-8 col-md-10 mx-auto">
                <h1 class="post-heading">日本VCレーダー 2023</h1>
                <span class="meta"> Posted in January 2024 </span>
<!--
                <figure>
                  <img class="img-fluid" src="img/blog/card/vc-radar-2023_thumbnail.png" alt="">
                </figure>
-->
                <p>恒例となりました2023年度版のVC Radar™を発表いたします。2023年に最も活発であった日本のリードVCを反映しています。</p>
                <p>具体的には、このインフォグラフィックは、日本の独立系ベンチャーキャピタルファンドが昨年国内スタートアップに対して行った新規投資案件の中でリード投資を行った件数を表しています。つまり、各VCにとってまだポートフォリオに含まれていない、新規のスタートアップのリード投資家を務めた投資のみがカウントされていることになります。</p>
<!--                <p>私たちは、このデータが成長する日本のスタートアップエコシステムにとって重要な情報であると信じています。データ根拠については、こちらをご覧ください（このデータをまとめてくださった真由美さんに感謝します！）。</p>
                <p>[注意事項: このインフォグラフィックは正確であるよう努めておりますが、間違いがある場合はお詫び申し上げます。修正のご要望がございましたら、お気軽に <a href="mailto:infographic@shizen.vc">infographic@shizen.vc</a>までご連絡ください。]</p>
-->
                <figure>  <img class="img-fluid" src="img/blog/card/VCRadar2023JP.png" alt=""></figure>


              </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
.post-heading,
.subheading,
.section-heading,
.blockquote,
.meta,
p,
span {
  color: #fff;
}
.post-heading {
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
}
.subheading {
  font-size: 20px;
  margin-top: 16px;
}
.section-heading {
  font-weight: 700;
  margin-top: 32px;
}
.section-heading + p {
  margin-top: 16px;
}
.meta + p {
  margin-top: 32px;
}
.author-info {
  font-size: 14px;
  font-style: italic;
  line-height: 1.5;
}
figure {
  margin-top: 24px;
}
</style>
